export enum NatureCompte {
	EffetDeCommerce = 'EFF',
	ManiementsDeFonds = 'MDF',
	Article15 = 'A15',
	VoiesExecution = 'VE',
	Placement='PLC',
	ChangementBanque = 'CDB'
}
